module.exports = __webpack_public_path__ + "fonts/Gibson-LightItalic.f9a57773.woff";